<template>
  <exception-page type="404"/>
</template>

<script>
	import {ExceptionPage} from '@/components'

	export default {
		name: "Exception404",
		components: {
			ExceptionPage
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/exception/404.vue